var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 11.25,
    viewBox: "0 0 16 11.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail",
    transform: "translate(0 -76)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    "data-name": "Group 5",
    transform: "translate(11 76.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M357.07,101.721l-4.859,4.82,4.859,4.82a1.388,1.388,0,0,0,.141-.6v-8.436A1.388,1.388,0,0,0,357.07,101.721Z",
    transform: "translate(-352.211 -101.721)",
    fill: "#072430"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(0.805 76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M39.509,76H26.323a1.388,1.388,0,0,0-.6.141l6.2,6.178a1.406,1.406,0,0,0,1.988,0l6.2-6.178A1.388,1.388,0,0,0,39.509,76Z",
    transform: "translate(-25.721 -76)",
    fill: "#072430"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(0 76.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M.141,101.721a1.388,1.388,0,0,0-.141.6v8.436a1.388,1.388,0,0,0,.141.6L5,106.541Z",
    transform: "translate(0 -101.721)",
    fill: "#072430"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    "data-name": "Group 11",
    transform: "translate(0.805 82.282)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M35.26,277.211l-.687.688a2.344,2.344,0,0,1-3.314,0l-.687-.687-4.852,4.827a1.388,1.388,0,0,0,.6.141H39.509a1.388,1.388,0,0,0,.6-.141Z",
    transform: "translate(-25.721 -277.211)",
    fill: "#072430"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.3010009fca756b83c9ada6d3c88cfc58.svg";
export { ForwardRef as ReactComponent };